<template>
  <div class="preloader">
    <div class="container">
      <div class="title">
        <img src="../assets/preloader.png" />
        <h1>
          A mission as big as ending hunger in Georgia requires one of the
          largest food banking facilities in the world. See for yourself.
        </h1>
      </div>
      <button
        @click="$store.commit('setLoad', false)"
        :class="{ disabled: $store.state.load }"
        class="enter-cta"
      >
        EXPLORE NOW
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "preloader",
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/colors";
@import "../assets/styles/typography";
@import "../assets/styles/breakpoints";
.preloader {
  background: $orange;
  display: flex;
  z-index: 10000;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  .container {
    width: 100%;
    max-width: 660px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .title {
      position: relative;
      box-sizing: border-box;
      padding: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        position: absolute;
      }
      h1 {
        top: 0;
        bottom: 0;
        color: white;
        @include media("<=tablet") {
          font-size: 43px;
          line-height: 40px;
          letter-spacing: 0.517857px;
        }
      }
      @include media("<=tablet") {
        padding: 30px;
      }
    }
  }
}
.enter-cta {
  position: relative;
  z-index: 10;
  margin-top: 40px;
  font-family: "omnes-pro", sans-serif;
  border: none;
  padding: 23px 64px;
  color: white;
  background: transparent;
  outline: none;
  transition: opacity 0.3s ease-in;
  cursor: pointer;
}
.disabled {
  pointer-events: none;
  opacity: 0.3;
}
</style>
